export default __webpack_public_path__ + "static/media/referral-sharing-popup.591224f5.jpg";